module.exports = __webpack_public_path__ + "img/yichu.32025e54.svg";